import { RoomPanelModalProvider } from '@/app/components/hotel-detail/rooms/RoomPanelModalProvider';
import { ChangeTransportDetailsModalProvider } from '@/app/components/hotel-detail/changeTransport/ChangeTransportDetailsModalProvider';
import { ChangeTransportModalProvider } from '@/app/components/hotel-detail/evo/transport/EvoChangeTransportCard/ChangeTransportModalProvider';
import { ChangeTransportModal } from '@/app/components/hotel-detail/evo/transport/EvoChangeTransportCard/ChangeTransportModal';
import { EvoModalsProvider } from '@/app/components/hotel-detail/evo/EvoModalsProvider';
import { EvoModals } from '@/app/components/hotel-detail/evo/EvoModals';
import { EvoChangeTransportDetailsModal } from '@/app/components/hotel-detail/evo/EvoChangeTransportDetailsModal';

export function EvoDetailsProviders(props: React.HTMLAttributes<HTMLElement>) {
  return (
    <RoomPanelModalProvider>
      <ChangeTransportModalProvider>
        <ChangeTransportModal />
        {/* MPH-985: the change-flight drawer above mounts a second instance of this provider (in
            TransportsSection) with its own isOpen and its own details modal, so this one names its
            ?modal= ids apart — sharing them let one back navigation open both modals at once. */}
        <ChangeTransportDetailsModalProvider modalIdPrefix="evo-transport-details">
          <EvoChangeTransportDetailsModal />
          <EvoModalsProvider>
            <EvoModals />
            {props.children}
          </EvoModalsProvider>
        </ChangeTransportDetailsModalProvider>
      </ChangeTransportModalProvider>
    </RoomPanelModalProvider>
  );
}
